import { useCallback, useRef } from 'react';

/**
 * Syncs horizontal scroll between two container refs.
 * Vertical scroll is independent — only scrollLeft is mirrored.
 */
export function useScrollSync() {
  const headerRef = useRef<HTMLDivElement | null>(null);
  const bodyRef = useRef<HTMLDivElement | null>(null);

  const attach = useCallback(() => {
    const header = headerRef.current;
    const body = bodyRef.current;
    if (!header || !body) return;

    const syncFromBody = () => { header.scrollLeft = body.scrollLeft; };
    const syncFromHeader = () => { body.scrollLeft = header.scrollLeft; };

    body.addEventListener('scroll', syncFromBody);
    header.addEventListener('scroll', syncFromHeader);

    return () => {
      body.removeEventListener('scroll', syncFromBody);
      header.removeEventListener('scroll', syncFromHeader);
    };
  }, []);

  const setHeaderRef = useCallback((node: HTMLDivElement | null) => {
    headerRef.current = node;
    attach();
  }, [attach]);

  const setBodyRef = useCallback((node: HTMLDivElement | null) => {
    bodyRef.current = node;
    attach();
  }, [attach]);

  return { headerRef: setHeaderRef, bodyRef: setBodyRef };
}
